import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className,
      style = props.style;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    className: className,
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 16 14",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account-Adminstration_Menu",
    transform: "translate(-47.000000, -351.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(0.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 161.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_palnts",
    transform: "translate(47.000000, 133.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,15 L0,6 L4,9 L4,6 L8,9 L8,6 L11.458,8.593 L11.786,4 L15.214,4 L16,15 L0,15 Z M4,11 L2,11 L2,13 L4,13 L4,11 Z M7,11 L5,11 L5,13 L7,13 L7,11 Z M10,11 L8,11 L8,13 L10,13 L10,11 Z M15,1 L15.143,3 L11.857,3 L12,1 L15,1 Z",
    id: "icon_plants"
  })))))));
});